import React, { useState } from "react";
import { RoleModel } from "../typings/models/RoleModel";
import { IUserModel } from "../typings/models/UserModel";
import { NavigationModel } from "../typings/models/NavigationModel";
import { IApplicationPayment } from "../typings/interfaces/Payment/ApplicationPayment";

export type AppContextData = {
  role: RoleModel;
  user: IUserModel;
  token: string;
  navigation: NavigationModel;
  payment: IApplicationPayment;
};
export const defaultAppContextData: AppContextData = {
  role: {} as RoleModel,
  user: {} as IUserModel,
  token: '' as string,
  navigation: {} as NavigationModel,
  payment: {} as IApplicationPayment,
};

export const AppContext = React.createContext<AppContextData>(
  defaultAppContextData
);

export type LabContextType = {
  parentValue: string;
  childValue: string;

};

const data = {
  parentValue: "Parent Body",
  childValue: "Child Body",
};

export const LabContext = React.createContext(data);
